import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IBaseModel } from 'src/app/models/base.model';
import { RiscosChavesServices } from 'src/app/services/riscos-chaves.service';
import { CriteriosAvaliacaoRiscoService } from 'src/app/services/criterios-avaliacao-risco.service';
import { TipoUniversoService } from 'src/app/services/tipo-universo.service';
import { IRiscosChavesModel, IRiscosChavesProcessoItemModel } from "src/app/models/riscos-chaves.model";
import { IUniversoAuditavelModel } from 'src/app/models/universo-auditavel.model';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { MatDialog } from '@angular/material/dialog';
import {
  ITipoUniversoModel,
  ITipoUniversoItemModel,
  ITipoUniversoUGModel
} from 'src/app/models/tipo-universo.model';
import Swal from "sweetalert2";
import { SharedService } from "../../../../services/shared.service";




@Component({
  selector: 'app-riscos-chaves-form',
  templateUrl: './riscos-chaves-form.component.html',
  styleUrls: ['./riscos-chaves-form.component.scss']
})
export class RiscosChavesFormComponent extends BaseFormComponent implements OnInit {

  public tipoUniversoId: number;
  public unidadeGestoraId: number;
  public criterioAvaliacaoId: number;
  public criterioId: string;
  public unidadeGestora: number;
  public processoId: number;
  public semDados: boolean;
  public modelRiscosChaves: IRiscosChavesModel = {} as IRiscosChavesModel;
  public modelTipoUniverso: ITipoUniversoModel = {} as ITipoUniversoModel;
  public modelTipoUniversoItens: ITipoUniversoUGModel = {} as ITipoUniversoUGModel;
  public modelRiscosChavesProcessoItemModel: IRiscosChavesProcessoItemModel[] = [];
  public idClassificacaoTipo: number;
  habilitaBotaoFinalizar: boolean = false;
  titulo: string = '';
  nomeRiscoChaves: string = '';


  constructor(route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private sharedService: SharedService,
    private riscosChavesService: RiscosChavesServices,
    private tipoUniversoService: TipoUniversoService,
    private criterioAvaliacaoService: CriteriosAvaliacaoRiscoService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);

    const params = this.sharedService.getParams();

    if(params === null){
      this.titulo = 'Novo';
    }else if(params.acao === 'responder'){
      this.titulo = 'Responder';
    } else if (params.acao === 'editar') {
      this.habilitaBotaoFinalizar = true;
      this.titulo = 'Editar';
    } else if (params.acao === 'visualizar') {
      this.habilitaBotaoFinalizar = true;
      this.titulo = 'Visualizar';
      this.visualizar = true;
    } else {
      this.titulo = 'Preencher';
    }
  }

  async ngOnInit() {

    if (this.id) {
      const res = await this.riscosChavesService.obterPorId(this.id);
      if (res.sucesso) {
        this.tipoUniversoId = res.dados.tipoUniversoAuditavelId;
        this.unidadeGestoraId = res.dados.unidadeGestoraId;
        this.criterioAvaliacaoId = res.dados.criterioAvaliacaoId;
        this.nomeRiscoChaves = res.dados.nomeTipoUniverso;

      }

    }
    if (this.tipoUniversoId != null) {
      this.buscarTipoUniverso(this.tipoUniversoId);
    }
  }

  public async buscarTipoUniverso(idTipo: number) {
    const res = await this.tipoUniversoService.obterPorId(idTipo);
    if (res.sucesso) {
      this.idClassificacaoTipo = res.dados.tipo;
    }

    this.buscarItens(this.tipoUniversoId, this.unidadeGestoraId);
  }

  retornoAbaRisco() {
    this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
  }

  public async buscarItens(idTipoUniverso: number, idUG: number) {
    const paramsUG = this.idClassificacaoTipo == 2 ? idUG : null;
    if (idTipoUniverso) {
      const res = await this.tipoUniversoService.obterItens(idTipoUniverso, paramsUG);
      if (res.sucesso) {
        this.modelTipoUniversoItens = res.dados;
        this.criterioId = this.criterioAvaliacaoId.toString();
      } else {
        this.exibirMensagemErro(res.mensagem.descricao);
      }

      this.obterDescricaoRisco();
      this.reordenar();
    }
  }

  public async abrirPreenchimento(processoId: number, modoVisualizar: boolean = false , subtipo: string = '', macroprocesso: string = '', processo: string = '') {

    const res = await this.criterioAvaliacaoService.obterPorId(this.criterioAvaliacaoId);
    if (res.sucesso) {
      if (this.id){
        localStorage.setItem('modoVisualizar', modoVisualizar.toString());
        this.router.navigate(
          [`/preenchimento-riscos-criterios`, this.id, processoId, this.unidadeGestoraId],
        );

        this.sharedService.setParamsRiscos(subtipo, macroprocesso, processo);
      }

    }

  }

  getRiscosPorProcesso(processoId: number) {
    const riscos = this.modelRiscosChavesProcessoItemModel.filter(risco => risco.processoId === processoId);
    return riscos.length > 0 ? riscos : [{ nomeRisco: '', ri: 0, rr: 0 }];
  }

  public obterDescricaoRisco() {
    this.riscosChavesService.obterItensProcesso(this.id, null).then(res => {
      if (res.sucesso) {
        this.modelRiscosChavesProcessoItemModel = Array.isArray(res.dados) ? res.dados : [res.dados];
      }
    })
  }

  getMagnitude(processos: any[]): { riTotal: number, rrTotal: number } {
    let riTotal = 0;
    let rrTotal = 0;

    processos.forEach(processo => {
      const riscos = this.modelRiscosChavesProcessoItemModel.filter(r => r.processoId === processo.id);

      riscos.forEach(risco => {
        riTotal += risco.ri || 0;
        rrTotal += risco.rr || 0;
      });
    });

    return {
      riTotal: parseFloat(riTotal.toFixed(2)),
      rrTotal: parseFloat(rrTotal.toFixed(2))
    };
  }

  getMagnitudeMacro(macros: any[]): { riTotal: number, rrTotal: number } {
    let riTotal = 0;
    let rrTotal = 0;

    macros.forEach(macro => {
      const magnitudeMacro = this.getMagnitude(macro.itens);
      riTotal += magnitudeMacro.riTotal;
      rrTotal += magnitudeMacro.rrTotal;
    });

    return {
      riTotal: parseFloat(riTotal.toFixed(2)),
      rrTotal: parseFloat(rrTotal.toFixed(2))
    };
  }

  getMagnitudeTotal(): { riTotal: number, rrTotal: number } {
    let riTotal = 0;
    let rrTotal = 0;

    if (!this.modelTipoUniversoItens?.itens || this.modelTipoUniversoItens.itens.length === 0) {
      return { riTotal: 0, rrTotal: 0 };
    }

    this.modelTipoUniversoItens.itens.forEach(subtipo => {
      const magnitudeSubtipo = this.getMagnitudeMacro(subtipo.itens ?? []);
      riTotal += magnitudeSubtipo.riTotal;
      rrTotal += magnitudeSubtipo.rrTotal;
    });

    return {
      riTotal: parseFloat(riTotal.toFixed(2)),
      rrTotal: parseFloat(rrTotal.toFixed(2))
    };
  }


  getRowSpan(subtipo: any): number {
    let rowCount = 0;
    subtipo.itens.forEach(macro => {
      if (macro.tipo === 2) {
        rowCount += macro.itens.length || 1; // Se não houver processos, contar pelo menos 1 linha
      }
    });
    return rowCount || 1; // Se não houver macros, contar pelo menos 1 linha
  }

  public onBack() {
    this.submit = false;
    this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
  }

  onFinalizar() {

    Swal.fire({
      title: "Finalizar  Preenchimento",
      text: "Tem certeza que deseja finalizar o preechimento riscos  chaves ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.riscosChavesService
          .finalizarRiscosChaves(this.id)
          .then((res) => {
            if (res.sucesso) {
              this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
              Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: 'success',
                text: 'Riscos Chaves Finalizado com Sucesso ',
              });
            } else {
              {
                Swal.fire({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                  icon: 'warning',
                  text: res.mensagem.descricao,
                });
              }
            }
          })
          .catch((err) => {
            {
              Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: 'error',
                text: err.mensagem.descricao,
              });
            }
          });
      }
    });

  }

  public reordenar() {
    this.modelTipoUniversoItens.itens.forEach((item, idx) => {
      item.ordem = (idx + 1);
      item.ordemExibicao = `1.${item.ordem.toString()}`;
      if (item.itens && item.itens.length > 0) {
        this.fnReordenacao(item);
      }
    });
  }

  public fnReordenacao(item: ITipoUniversoItemModel) {
    item.itens.forEach((subItem, subIdx) => {

      subItem.ordem = subIdx + 1;
      subItem.ordemExibicao = `${item.ordemExibicao}.${subItem.ordem.toString()}`
      if (subItem.itens && subItem.itens.length > 0) {
        this.fnReordenacao(subItem);
      }
    });
  }

}


